import { Box, Typography } from "@mui/material"
import { useStyles } from "../styles"
import { EvidencesListProps } from "../types"

export const EvidenceList = ({ filesDontUpload, titleFilesDontUpload, evidencesEithTheSameNAme, titleEvidencesEithTheSameNAme }: EvidencesListProps) => {
    const styles = useStyles()
    return (
        (
            <Box sx={styles.containerUl}>
                {
                    !!filesDontUpload?.length && (
                        <Box sx={styles.containerErrors}>
                            <Typography sx={styles.titleModal}>{titleFilesDontUpload}</Typography>

                            <ul>
                                {filesDontUpload.map((item) => (
                                    <li>{item}</li>
                                ))}
                            </ul>
                        </Box>)
                }

                {
                    !!evidencesEithTheSameNAme?.length && (
                        <Box sx={styles.containerErrors}>
                            <Typography sx={styles.titleModal}>{titleEvidencesEithTheSameNAme}</Typography>

                            <ul>
                                {evidencesEithTheSameNAme.map((item) => (
                                    <li>{item}</li>
                                ))}
                            </ul>
                        </Box>)
                }
            </Box>
        )
    )
}